<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.6665 10C1.6665 10 4.1665 4.16667 9.99984 4.16667C15.8332 4.16667 18.3332 10 18.3332 10C18.3332 10 15.8332 15.8333 9.99984 15.8333C4.1665 15.8333 1.6665 10 1.6665 10Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
  export default {
    name: 'eye'
  }
</script>



// WEBPACK FOOTER //
// src/ui/icon/Eye.vue